/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MicrosoftInputs */

const cs_enum_microsoft = /** @type {(inputs: Enum_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const en_enum_microsoft = /** @type {(inputs: Enum_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

/**
* | output |
* | --- |
* | "Microsoft" |
*
* @param {Enum_MicrosoftInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_microsoft = /** @type {((inputs?: Enum_MicrosoftInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MicrosoftInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_microsoft(inputs)
	return cs_enum_microsoft(inputs)
});